import {type PersistableAppState} from './types/persistable-app-state'

const localStorageKey = 'cyberowl-customer-portal'

export function loadState(): PersistableAppState | undefined {
    try {
        const serializedState: string | null = localStorage.getItem(localStorageKey)
        if (serializedState == null) {
            return undefined
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(serializedState)
    } catch {
        return undefined
    }
}

export function saveState(state: PersistableAppState): void {
    try {
        const serializedState: string = JSON.stringify(state)

        localStorage.setItem(localStorageKey, serializedState)
    } catch {
        // noop
    }
}
